
import matter from "gray-matter";
import { Buffer } from "buffer";

window.Buffer = window.Buffer || Buffer; // Polyfill for browser

// Fetch the index.json to get list of posts
export const getAllPosts = async () => {
    try {
        const response = await fetch("/content/blog/index.json");
        if (!response.ok) throw new Error("Failed to fetch blog index");
        const posts = await response.json();

        // Return array of { slug, path: "/content/blog/xxxx.md" }
        return posts.map(p => ({
            slug: p.slug,
            path: p.file
        }));
    } catch (err) {
        console.error("Error loading blog index:", err);
        return [];
    }
};

// Fetch a specific post content
export const getPostData = async (path) => {
    try {
        const response = await fetch(path);
        if (!response.ok) throw new Error("Failed to load post");
        const text = await response.text();
        const { data, content } = matter(text);

        return { ...data, content };
    } catch (err) {
        console.error("Error parsing post:", err);
        return null;
    }
};
